import { useEffect, useRef, useState, useCallback } from "react";

// Autoguardado local de borradores en curso. Guarda el formulario en localStorage
// mientras se captura; si la app se cierra/recarga, permite recuperarlo al reabrir.
// - storageKey: clave única por tipo de documento (p.ej. "selec_draft_quotation")
// - enabled: true solo cuando el diálogo de creación está abierto
// - value: el objeto del formulario a persistir
// - isEmpty(value): evita guardar cuando el formulario está vacío
export function useFormDraft({ storageKey, enabled, value, isEmpty }) {
  const [draftAvailable, setDraftAvailable] = useState(false);

  // Detecta un borrador existente al abrir (una sola vez por apertura).
  useEffect(() => {
    if (!enabled) { setDraftAvailable(false); return; }
    try { setDraftAvailable(!!localStorage.getItem(storageKey)); }
    catch { setDraftAvailable(false); }
  }, [enabled, storageKey]);

  // Guarda con debounce mientras se edita.
  useEffect(() => {
    if (!enabled) return;
    const t = setTimeout(() => {
      try {
        if (isEmpty && isEmpty(value)) return;
        localStorage.setItem(storageKey, JSON.stringify(value));
      } catch {}
    }, 600);
    return () => clearTimeout(t);
  }, [value, enabled, storageKey, isEmpty]);

  const loadDraft = useCallback(() => {
    try { const raw = localStorage.getItem(storageKey); return raw ? JSON.parse(raw) : null; }
    catch { return null; }
  }, [storageKey]);

  const clearDraft = useCallback(() => {
    try { localStorage.removeItem(storageKey); } catch {}
    setDraftAvailable(false);
  }, [storageKey]);

  return { draftAvailable, loadDraft, clearDraft };
}
